import { gql } from '@apollo/client'

import { METADATA_NODE_FRAGMENT } from '../../../common/graphql/fragments'

const INGREDIENT_NODE_FRAGMENT = gql`
  fragment IngredientNodeFragment on IngredientNode {
    ...MetadataNodeFragment
    isWholeFood
    isVague
    hasUncategorizedKeywords

    replaces {
      ...MetadataNodeFragment
      replaceToken
    }

    replacedBy {
      ...MetadataNodeFragment
      replaceToken
    }

    children {
      ...MetadataNodeFragment
      isWholeFood
      isVague
      hasUncategorizedKeywords

      replaces {
        ...MetadataNodeFragment
        replaceToken
      }

      replacedBy {
        ...MetadataNodeFragment
        replaceToken
      }

      children {
        ...MetadataNodeFragment
        isWholeFood
        isVague
        hasUncategorizedKeywords

        replaces {
          ...MetadataNodeFragment
          replaceToken
        }

        replacedBy {
          ...MetadataNodeFragment
          replaceToken
        }
      }
    }
  }
  ${METADATA_NODE_FRAGMENT}
`

export default INGREDIENT_NODE_FRAGMENT
